import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import logo from "../../images/logo.png";
import OverLay from "./OverLay";
import { UserContext } from "../UserContext";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { Typeahead } from "react-bootstrap-typeahead";

function NavBar({ search, user, props }) {
  const allservices = [
    "Food and drinks Hub",
    "Catering and Restaurants Hub",
    "Hair products and Hair styling Hub",
    "Automobile Services",
    "Makeup and Skincare Hub",
    "Photography Hub",
    "Fabrics and Tailoring Hub",
    "Courier services Hub",
    "Event planners Hub",
    "Educational Services Hub",
    "Art and Crafts Hub",
    "Books and Authors Hub",
    "Property and Accommodation Hub",
    "Laundry and Cleaning Services Hub",
    "Fashion and Accessories Hub",
    "Tech and Electronics Hub",
    "Health and fitness Hub",
    "Home and decor Hub",
    "Gifting and personal shopping Hub",
    "Legal Services Hub",
    "Accounting Services Hub",
  ];
  const [city, setCity] = useState("");
  const [multiple] = useState(false);
  const [service, setService] = useState([]);
  const users = useContext(UserContext);
  function logOut() {
    users.setUser(null);
    localStorage.removeItem("access_token");
  }
  function onSearchSubmit() {
    if (service.length > 0 && city.length > 0) {
      props.history.push(`/listing/service=${service[0]}&city=${city}`);
    } else if (service.length > 0 && city.length < 1) {
      props.history.push(`/listing/service=${service[0]}`);
    } else if (service.length < 1 && city.length > 0) {
      props.history.push(`/listing/service=${" "}&city=${city}`);
    }
  }

  return (
    // <nav className="navbar navbar-expand-lg navbar-light">
    <Navbar
      collapseOnSelect
      className="navbar-light navvv"
      expand="lg"
      variant="dark"
    >
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src={logo} alt="logo" />
        </Link>
        {search && (
          <div className="ml-3 search_bar row justify-content-center">
            <div className="row">
              <div className="col-md-10 col-sm-12 row">
                <div className="col-6 p-0">
                  <div className="input-group">
                    <div className="input-group-prepend ">
                      <div className="input-group-text bg-white bod-left-rad ">
                        what
                      </div>
                    </div>
                    <Typeahead
                      id="basic-typeahead-example"
                      labelKey="name"
                      className="form-control border-left-0 p-0 typehead form-control-lg input_1"
                      onChange={setService}
                      multiple={multiple}
                      options={allservices.sort((item1, item2) =>
                        item1 > item2 ? 1 : -1
                      )}
                      placeholder="Choose a service"
                      selected={service}
                    />
                  </div>
                </div>
                <div className="col-6 p-0">
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text bg-white rounded-0">
                        where
                        <i
                          className="fa fa-map-marker fs-16 p-0 text-dark p-0 ml-1"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </div>
                    <input
                      type="text"
                      className="form-control p-0 border-left-0 form-control-lg input_2"
                      placeholder="Your City..."
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-sm-12  d-flex  justify-content-center mt-md-0 mt-lg-0 mt-2">
                <button
                  onClick={onSearchSubmit}
                  className="btn btn-danger btn-lg addbtn"
                >
                  <i className="fal fa-search p-0"></i>
                </button>{" "}
              </div>
            </div>
          </div>
        )}
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          className="bg-black"
        />
        {/* <div
          className="collapse navbar-collapse mw-3 justify-content-end"
          id="navbarNavDropdown"
        > */}
        <Navbar.Collapse
          className="mw-3  justify-content-end"
          id="responsive-navbar-nav"
        >
          <Nav>
            <li className="nav-item">
              {user ? (
                <OverLay user={user} logOut={logOut} />
              ) : (
                <Link className="nav-link  black-text" to="/login">
                  <i className="fal fa-user-circle  black-text pr-1"></i>
                  Join Now
                </Link>
              )}
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/packages">
                <button
                  style={{ padding: "5px 13px" }}
                  className="btn btn-danger btn-lg addbtn"
                >
                  {/* <i className="fa fa-plus p-0" />  */}
                  <span>View Packages</span>
                </button>
              </Link>
            </li>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
}

export default NavBar;
